import axiosClient from "utils/api";
const URI = "/admin/employement";

export const getEmployement = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get employement:", error);
    throw error;
  }
};

export const deleteEmployement = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete employement:", error);
    throw error;
  }
};

export const updateEmployement = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update employement:", error);
    throw error;
  }
};

export const addEmployement = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add employement:", error);
    throw error;
  }
};
